$('.js-accordionTitle').click(function(){
	if($(this).hasClass('is-open')){
		$(this).removeClass('is-open')
	}else{
		$(this).addClass('is-open')
	}
	$(this).next('.p-lp1Contents15__detailDescription, .p-lp2Contents16__detailDescription, .p-lp3Contents16__detailDescription').slideToggle();
})
